module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-11.50e485a7.jpg";